import { useSelector } from 'react-redux';

import { describeAiSearchResults } from '@/services/aiSearch/describeResults';
import { paramsToAiSearch } from '@/services/aiSearch/paramsToAiSearch';

import { useAiSearch } from './AiSearchContext';

/**
 * Airbnb-style heading above /rv-search results after an AI search ("These
 * cozy camper vans near Asheville, NC can welcome you from November 6.").
 * Rebuilt from the current URL filters, so it follows later facet changes.
 * Renders nothing unless AI search is on and an AI search ran this session.
 */
export default function AiSearchResultsHeading() {
  const { available, enabled, lastSearch } = useAiSearch();
  const queryParams = useSelector(
    (state: { queryParams: Record<string, string> }) => state.queryParams,
  );

  if (!available || !enabled || !lastSearch) return null;

  return (
    <h2 className="mb-4 text-2xl font-semibold leading-tight text-gray-900 md:text-3xl">
      {describeAiSearchResults(paramsToAiSearch(queryParams || {}), lastSearch.vibes)}
    </h2>
  );
}
